@import '../styles/palette.scss';
@import '../styles/fonts.scss';
@import '../styles/mixins.scss';
@import '../styles/deviceBreakpoints.scss';

.buttonContainer {
  display: flex;
  float: right;
  padding-top: 1rem;
}

.buttonContainer button {
  margin: 2rem 0.625rem;
}

.space65 {
  @include space(65);
}

.space15 {
  @include space(15);
}

.dashboard {
  @include barlow(16);

  @include target(tablet) {
    @include barlow(14);
  }

  p {
    max-width: 31rem;
  }

  .card {
    @include card();
    flex-wrap: wrap;
    margin-bottom: 2em;
    display: flex;
    flex: auto;

    &.flexColumn {
      flex-direction: column;
    }

    .content {
      margin-top: 1em;
      max-width: 100%;
      width: 100%;
    }

    .date {
      margin-bottom: 2em;
    }

    .leftContainer {
      flex: 0 1 60%;
    }

    .rightContainer {
      flex: 0 1 40%;
    }

    .title {
      width: 100%;
    }

    .subtitle {
      width: 100%;

      @include barlow(16);

      @include target(tablet) {
        @include barlow(14);
      }
    }

    h2 {
      @include merriweather(20);

      @include target(tablet) {
        @include merriweather(16);
      }
    }

    .officeIllustration {
      background-image: url('./ill_dashboardwelcome.svg');
      background-position: top right;
      background-repeat: no-repeat;
      background-size: contain;
      margin-top: -2.5rem;
      max-width: 22rem;
      min-height: 3.125rem;
      min-width: 6.25rem;
      position: relative;

      @media only screen and (min-width: 640px) {
        margin-top: -3.75rem;
        min-height: 6.25rem;
      }

      @media only screen and (min-width: 1280px) {
        margin-top: -5rem;
        min-height: 9.4rem;
      }
    }

    &:first-child {
      margin-top: 4em;
    }
  }
}

.statusHeader {
  width: 1%;
}

.statusState {
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;

  .statusColor {
    height: 1em;
    width: 1.5em;
    margin: 0 1em;
    border-radius: 3px;

    &.statusOk {
      background-color: green;
    }

    &.statusFeiletDogn {
      background-color: _palette(warning-icon);
    }

    &.statusFeilet {
      background-color: _palette(text-red);
    }
  }
}

.errorMsg {
  display: flex;
  align-items: center;
  gap: 1em;
  margin-bottom: 1em;
  justify-content: space-between;

  .clearBtn {
    @include barlow(14);
    height: 1.25em;
  }
}

.feilmeldingerParagraph {
  @include barlow(14);
}

.activityTableWrapper {
  margin-top: 1rem;

  .caption {
    @include barlowMedium(20);
  }

  .table {
    margin-top: 0.25rem;
  }
}
